import { render, staticRenderFns } from "./wrap.vue?vue&type=template&id=506b4056&scoped=true"
import script from "./wrap.vue?vue&type=script&lang=js"
export * from "./wrap.vue?vue&type=script&lang=js"
import style0 from "./wrap.vue?vue&type=style&index=0&id=506b4056&prod&lang=scss"
import style1 from "./wrap.vue?vue&type=style&index=1&id=506b4056&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506b4056",
  null
  
)

export default component.exports